import React, { useState } from "react";
import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
import { RiEyeOffFill, RiEyeFill } from "react-icons/ri";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const ResetPassword = (props) => {
  const navigate = useNavigate();
  const OTP = localStorage.getItem("OTP").split(",").join("");
  const AUTH_TOKEN = localStorage.getItem("authToken");
  //   console.log(AUTH_TOKEN);

  // const navigate = useNavigate(),
  const [resetDetails, setResetDetails] = useState({
      newPassword: "",
      //   confirmPassword: "",
    }),
    [loading, setLoading] = useState(false),
    [errorMessage, setErrorMessage] = useState(""),
    [showPassword, setShowPassword] = useState(false);

  // Handle password visibility
  const togglePasswordVisibilty = () => {
    setShowPassword(!showPassword);
  };

  // Handle error message
  const handleErrorMessage = (err) => {
    const error = err.message[0].msg || err.message;
    setErrorMessage(error);
  };

  const handleChange = (event) => {
    setResetDetails((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  //   Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      newPassword: resetDetails.newPassword,
      otp: OTP,
      authToken: AUTH_TOKEN,
    };
    console.log(data);
    // turn the loading effect
    setLoading(true);

    try {
      const response = await fetch(
        `https://studyapp-api.vercel.app/api/v1/password-reset/verify-otp`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const responseData = await response.json();
      // console.log(responseData);

      // Handle the error message
      handleErrorMessage(responseData);

      //Update the email value state
      setResetDetails((prev) => {
        return {
          ...prev,
          ...responseData,
        };
      });
      //   console.log(email);

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <section className="forgot-password reset-password">
        <form className="form-container" onSubmit={handleSubmit}>
          <div className="form-wrapper">
            <div className="form-header">
              <h3>Reset password</h3>
            </div>
            <div className="form-body">
              <div className="form-field">
                <label htmlFor="newPassword">new password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="newPassword"
                  name="newPassword"
                  value={resetDetails.newPassword}
                  onChange={handleChange}
                />
                <span onClick={togglePasswordVisibilty} className="eye-icon">
                  {showPassword ? <RiEyeOffFill /> : <RiEyeFill />}
                </span>
              </div>
              {/* <div className="form-field">
                <label htmlFor="comfirmPassword">comfirm password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={resetDetails.confirmPassword}
                  onChange={handleChange}
                />
              </div> */}
            </div>
            {/* return error message*/}
            {resetDetails.status === "success" ? (
              <span style={{ color: "green" }}>{errorMessage} </span>
            ) : (
              <span style={{ color: "red" }}>{errorMessage}</span>
            )}
            <div className="form-footer">
              <div className="form-field">
                <div className="flex-2">
                  <div className="cta-btn">
                    <Link to="/reset-password-token">back</Link>
                  </div>
                  <div className="cta-btn">
                    {resetDetails.status === "success" ? (
                      navigate("/reset-password-successful")
                    ) : (
                      <button>submit</button>
                    )}
                  </div>
                </div>

                {loading ? (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                ) : null}
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
  );
};

export default ResetPassword;
